import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router'

import CheckPoint from '../../icons/CheckPoint'
import Logo from '../../icons/Logo'

const NoleggiaHeader = ({ onLogoClick, postLeadClickToCall, router, ui }) => (
  <header className="hide-print">
    <div className="header__container">
      <div className="header__left">
        <div className="header__back" onClick={() => router.goBack()}>
          <span></span>
        </div>
        <a className="header__logo" onClick={onLogoClick} title="brumbrum">
          <Logo />
        </a>
      </div>

      <div
        className={`header__middle ${
          ui.phase <= 0 ? 'header__middle--hidden' : ''
        }`}
      >
        <a
          className="only-mobile"
          href={`tel:${ui.settings.phoneNumber}`}
          onClick={postLeadClickToCall}
          title="Servizio Clienti"
        >
          <i className="icon-phone-bold"></i>
          <span>&nbsp;&nbsp;02.800.29</span>
        </a>
        <div className="process_menu">
          <ul>
            {ui.phase < 40 && (
              <li className="level0">
                <Link
                  className={`${
                    ui.phase === 10
                      ? 'current'
                      : ui.last >= 10
                      ? 'clickable'
                      : 'disabled'
                  } ${ui.phase >= 10 ? 'active' : ''}`}
                  title="Canone"
                  to={'/scegli-canone'}
                >
                  <span>
                    <CheckPoint />
                    Canone
                  </span>
                </Link>
              </li>
            )}

            {ui.phase < 40 && (
              <li className="level0">
                <Link
                  className={`${
                    ui.phase === 20
                      ? 'current'
                      : ui.last >= 10
                      ? 'clickable'
                      : 'disabled'
                  } ${ui.phase >= 20 ? 'active' : ''}`}
                  style={ui.last >= 10 ? null : { pointerEvents: 'none' }}
                  title="Servizi"
                  to={'/servizi-plus'}
                >
                  <span>
                    <CheckPoint />
                    Servizi
                  </span>
                </Link>
              </li>
            )}

            {ui.phase < 40 && (
              <li className="level0">
                <Link
                  className={`${
                    ui.phase === 30
                      ? 'current'
                      : ui.last >= 20
                      ? 'clickable'
                      : 'disabled'
                  } ${ui.phase >= 30 ? 'active' : ''}`}
                  style={ui.last >= 20 ? null : { pointerEvents: 'none' }}
                  title="Richiesta Noleggio"
                  to={'/richiesta-noleggio'}
                >
                  <span>
                    <CheckPoint />
                    Richiesta Noleggio
                  </span>
                </Link>
              </li>
            )}

            {ui.phase < 100 && (
              <li className="level0">
                <Link
                  className={`${
                    ui.phase === 40
                      ? 'current'
                      : ui.last >= 30
                      ? 'clickable'
                      : 'disabled'
                  } ${ui.phase >= 40 ? 'active' : ''}`}
                  style={ui.last >= 30 ? null : { pointerEvents: 'none' }}
                  title="Carica Documenti"
                  to={'/documents'}
                >
                  <span>
                    <CheckPoint />
                    Carica Documenti
                  </span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="header__right">
        <div className="header--item">
          <ul>
            <li className="level0">
              <a
                className="js-support-hover"
                href={`tel:${ui.settings.phoneNumber}`}
                onClick={postLeadClickToCall}
                title="Servizio Clienti"
              >
                <i className="icon-phone-bold" />
                <span>&nbsp;&nbsp;02.800.29</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
)

NoleggiaHeader.propTypes = {
  onLogoClick: PropTypes.func,
  postLeadClickToCall: PropTypes.func.isRequired,
  ui: PropTypes.object.isRequired,
}

export default NoleggiaHeader
